import { NavigationPage, ScrollIndicator } from '@/app/components'
import { useNavigation } from '@/app/hooks'
import energySystemImageSrc from '@/app/img/energy-system-lg.webp'
import { Button } from '@/components'
import OrderedListItem, {
  OrderedList,
  OrderedListContent,
} from '@/components/OrderedList/OrderedListItem'
import { BreakpointContext } from '@/context'
import { useContext } from 'react'
import { useRouteMatch } from 'react-router-dom'

export default function EnergySystemValueProp() {
  const { url } = useRouteMatch()
  const breakpoint = useContext(BreakpointContext)
  const navigation = useNavigation()

  const onContinue = () => {
    navigation.push(`${url}/select`)
  }

  return (
    <NavigationPage
      id="energy-system-value-prop"
      title="Connect Battery"
      subtitle="Power up your savings – Optiwatt intelligently manages your battery to maximize value and efficiency"
    >
      <NavigationPage.SingleCardContent>
        <div className="w-full flex justify-center mb-5">
          <img
            className="h-[235px]"
            src={energySystemImageSrc}
            alt="Tesla Powerwall battery"
          />
        </div>
        {breakpoint.xsOnly && (
          <ScrollIndicator label="Scroll for more" className="mb-8" />
        )}
        <OrderedList className="mb-9">
          <OrderedListItem
            backgroundColor="bg-themed-blue-100"
            textColor="text-themed-blue-500"
          >
            <OrderedListContent
              title="Join demand response events"
              subtitle="Take part in demand response events where your battery helps reduce grid stress and get rewarded."
            />
          </OrderedListItem>
          <OrderedListItem
            backgroundColor="bg-themed-blue-100"
            textColor="text-themed-blue-500"
          >
            <OrderedListContent
              title="Stay on top of your energy"
              subtitle="See how much energy your battery is storing, using, and contributing — anytime."
            />
          </OrderedListItem>
          <OrderedListItem
            backgroundColor="bg-themed-blue-100"
            textColor="text-themed-blue-500"
          >
            <OrderedListContent
              title="Use energy wisely (Coming soon)"
              subtitle="Optiwatt intelligently manages when and how your battery charges and discharges."
            />
          </OrderedListItem>
        </OrderedList>
        <Button
          variant="primary"
          id="energy-system-value-prop-continue"
          onClick={onContinue}
        >
          Continue
        </Button>
      </NavigationPage.SingleCardContent>
    </NavigationPage>
  )
}
